export default __webpack_public_path__ + "4c23efe7541cb81742d61e27e9209cd4.png";